import URLSearchParams from 'url-search-params';

function getQueryString(obj, defaults={}) {
  return new URLSearchParams(Object.assign(defaults, obj)).toString();
}

export {getQueryString};
